import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AtpTitleComponent } from './atp-title.component';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [
    AtpTitleComponent
  ],
  imports: [
    CommonModule,
    MatIconModule
  ],
  exports: [
    AtpTitleComponent
  ]
})
export class AtpTitleModule { }
